import * as React from 'react';

import classNames from 'classnames';

import { SvgChevronLeft, SvgChevronRight } from '@coursera/coursera-ui/svg';

import 'css!bundles/ui/components/DatePicker/__styles__/DatePickerNavButton';

type Props = {
  isBack?: boolean;
  color?: string;
};

export default ({ isBack, color }: Props) => {
  const IconComponent = isBack ? SvgChevronLeft : SvgChevronRight;
  const classModifier = isBack ? 'back' : 'forward';

  return (
    <button className={classNames('rc-DatePickerNavButton', classModifier)} type="button">
      <IconComponent size={24} color={color} />
    </button>
  );
};
